import React from 'react';
import ContentPages from '../../components/AdminNext/ContentPages';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Content pages — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <ContentPages />
      </HeadLessLayout>
    )
  };
}

export default action;
